import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MediaAsset } from 'src/app/models/assets/MediaAsset';
import { AssetManagementService } from 'src/app/services/asset-management.service';
import { ModalController, AlertController } from '@ionic/angular';
import { DeepCopyService } from 'src/app/services/deep-copy.service';
import { AssetTypeService } from 'src/app/services/asset-type.service';
import { ViewAssetModalPage } from '../view-asset-modal/view-asset-modal.page';
import { ValidationService } from 'src/app/services/validation.service';
import { FileService } from 'src/app/services/file.service';
import { AssetInScene } from 'src/app/models/AssetInScene';

@Component({
  selector: 'app-question-response-object-edit-modal',
  templateUrl: './question-response-object-edit-modal.page.html',
  styleUrls: ['./question-response-object-edit-modal.page.scss'],
})
export class QuestionResponseObjectEditModalPage implements OnInit {

  public title: string;
  public assetType: string;
  public asset: AssetInScene;
  public currentTab: string = 'Home';
  public assetsOnAssetManagementPage: MediaAsset[] = [];
  public assetsOnAssetManagementPageCopy: MediaAsset[] = [];
  public searchNotFound: boolean = false;
  public assetSearchTerm: string;
  public selectedAssetIDToCopy: number = -1;
  public assetIDToCopy: number = -1;
  public selectedSrcUploaded: string = '';
  public fileUploaded: boolean = false;
  public srcUploaded: string = '';
  public compressVideo: boolean = false;
  public previewingProperties: boolean = false;
  public oldSrc: string;

  private _isModalOpen: boolean = false;

  constructor(
    private sanitizer: DomSanitizer,
    public modalController: ModalController,
    public alertController: AlertController,
    public assetManagementService: AssetManagementService,
    public deepCopyService: DeepCopyService,
    public assetTypeService: AssetTypeService,
    public validationService: ValidationService,
    public fileService: FileService
  ) { }

  async ngOnInit() {
    let mediaAsset = this.asset.baseAsset as MediaAsset;
    if (this.assetManagementService.assets === undefined || this.assetManagementService.assets.length === 0) {
      await this.assetManagementService.getAssetsOnManagementPage();
    }
    this.assetsOnAssetManagementPage = this.deepCopyService.deepCopy(this.assetManagementService.assets.filter(x => x.assetTypeId == this.asset.baseAsset.assetTypeId));
    this.assetsOnAssetManagementPageCopy = this.deepCopyService.deepCopy(this.assetManagementService.assets.filter(x => x.assetTypeId == this.asset.baseAsset.assetTypeId));

    this.oldSrc = mediaAsset.src;

    //CHECK IF ASSET IF FROM ASSET MANAGEMENT PAGE
    if(this.assetsOnAssetManagementPage.find(x => x.baseAssetId == this.asset.baseAsset.baseAssetId)){
      this.selectedAssetIDToCopy = this.asset.baseAsset.baseAssetId;
      this.assetIDToCopy = this.asset.baseAsset.baseAssetId;
    }
  }

  closeModal() {
    let mediaAsset = this.asset.baseAsset as MediaAsset;
    mediaAsset.src = this.oldSrc;
    this.modalController.dismiss();
  }

  goToTab(tab: string){
    this.currentTab = tab;
  }

  changedAssetIDtoCopy(event){
    let mediaAsset = this.asset.baseAsset as MediaAsset;
    let selectedAsset = this.assetsOnAssetManagementPage.find(b => b.baseAssetId == event.target.value);
    mediaAsset.src = selectedAsset.src;
  }

  searchByAsset(event) {
    let name: string = event.target.value ? event.target.value : '';
    
    this.assetsOnAssetManagementPage = this.deepCopyService.deepCopy(this.assetsOnAssetManagementPageCopy);
    var assets = this.assetsOnAssetManagementPage.filter(x => x.name.toLowerCase().includes(name.toLowerCase()));
    if (assets.length === 0) {
      this.searchNotFound = true;
      this.assetsOnAssetManagementPage = this.deepCopyService.deepCopy(this.assetsOnAssetManagementPageCopy);
    }
    else {
      this.searchNotFound = false;
      this.assetsOnAssetManagementPage = assets;
    }
  }

  launchPreviewAsset(){
    let mediaAsset = this.asset.baseAsset as MediaAsset;
    if(this.selectedAssetIDToCopy > -1){
      mediaAsset = this.assetsOnAssetManagementPage.find(a => a.baseAssetId == this.selectedAssetIDToCopy);
    }
    this.launchAsset(mediaAsset);
  }

  launchPreviewUploadedAsset(){
    let mediaAsset = this.deepCopyService.deepCopy(this.asset.baseAsset);
    mediaAsset.src = this.srcUploaded;
    this.launchAsset(mediaAsset);
  }

  async launchAsset(asset) {

    if(this._isModalOpen === true) return;
    this._isModalOpen = true;

    var oldSrc = asset.src;
    asset.src = this.sanitizer.bypassSecurityTrustUrl(oldSrc);

    const modal = await this.modalController.create({
      component: ViewAssetModalPage,
      id: 'asset-preview-' + this.assetTypeService.getType(asset.assetTypeId) + '-modal',
      componentProps: {
        "assetModalData": asset
      }
    });

    modal.onDidDismiss().then(() => {
      asset.src = oldSrc;
      this._isModalOpen = false;
    });

    return await modal.present();
  }

  setSelectedAsset(){
    this.assetIDToCopy = this.selectedAssetIDToCopy;
    this.goToTab('UploadFromMediaManagementPage'); 
  }

  selectAssetOnManagementPage(){
    this.selectedAssetIDToCopy = this.assetIDToCopy;
    this.selectedSrcUploaded = '';
    this.resetResponseObjectSrc();
    this.goToTab('Home');
  }

  selectUploadedFile(){
    this.selectedSrcUploaded = this.srcUploaded;
    this.asset.baseAsset['src'] = this.selectedSrcUploaded;
    this.selectedAssetIDToCopy = -1;
    this.resetResponseObjectSrc();
    this.goToTab('Home');
  }

  setUpFileType(event) {
    this.validationService.setFileType(event);
    if(!this.validationService.isFileFormatCorrect(this.asset.baseAsset.assetTypeId)){
      this.srcUploaded = '';
      this.validationService.createAlert('Wrong Media Type Uploaded.');
    }
  }

  selectFile(event) {
    this.srcUploaded = URL.createObjectURL(event.target.files[0]);    
  }

  uploadFile(files): Promise<string> {
    return this.fileService.fileEventUpload(files, '5a0ffb5a-475d-4307-bf05-237f82a9302d', this.compressVideo);
  }

  previewProperties(){
    this.previewingProperties = !this.previewingProperties;
    this.setTransparency('question-response-object-edit-modal', this.previewingProperties === true ? 0.3 : 1);
  }

  setTransparency(elementId: string, opacity: number) {
    document.getElementById(elementId).setAttribute('style', 'opacity: ' + opacity);
  }

  changeAssetProperties(prop: string, valueToAdd: number){
    let oldValue: number = Number(this.asset.sceneAssetRelation[prop]);
    this.asset.sceneAssetRelation[prop] = String(oldValue + valueToAdd);
    this.validateSceneAssetRelationProperties();
  }

  validateSceneAssetRelationProperties(){
    let xPos: number = Number(this.asset.sceneAssetRelation.xPos);
    let yPos: number = Number(this.asset.sceneAssetRelation.yPos);
    let xScale: number = Number(this.asset.sceneAssetRelation.xScale);
    let yScale: number = Number(this.asset.sceneAssetRelation.yScale);

    if(xPos > 1) xPos = 1;
    else if(xPos < -1) xPos = -1;

    if(yPos > 1) yPos = 1;
    else if(yPos < -1) yPos = -1;

    if(xScale > 2) xScale = 2;
    else if(xScale < 0.1) xScale = 0.1;

    if(yScale > 2) yScale = 2;
    else if(yScale < 0.1) yScale = 0.1;

    if(this.assetType === 'Audio'){
      yScale = xScale / 2;
    }

    xPos = Number(xPos.toFixed(3));
    yPos = Number(yPos.toFixed(3));
    xScale = Number(xScale.toFixed(3));
    yScale = Number(yScale.toFixed(3));

    this.asset.sceneAssetRelation = {
      ...this.asset.sceneAssetRelation,
      xPos: String(xPos),
      yPos: String(yPos),
      xScale: String(xScale),
      yScale: String(yScale)
    };

    this.setUpSceneAssetRelationScaleAndPosition();
    this.showResponseObject();
  }

  setUpSceneAssetRelationScaleAndPosition(){
    let { xPos, yPos, zPos, xScale, yScale, zScale} = this.asset.sceneAssetRelation;
    this.asset.sceneAssetRelation.position = `${xPos} ${yPos} ${zPos}`;
    this.asset.sceneAssetRelation.scale = `${xScale} ${yScale} ${zScale}`;
  }

  showResponseObjectProperties(){
    this.showResponseObject();
    this.goToTab('objectProperties');
  }

  showResponseObject(){
    let responseObjectButton = this.getResponseObjectButton(this.asset.sceneAssetRelation.sceneAssetRelationId);
    if(responseObjectButton){
      responseObjectButton.click();
      let entityId = responseObjectButton.getAttribute('entity-id');
      let entityObjects = document.querySelectorAll("[entity-id$='"+entityId+"'][response-object]");

      entityObjects.forEach(entityObject => {
        let src = document.querySelector(entityObject.getAttribute('src'));
        if (src && (entityObject.tagName == 'A-VIDEO' || entityObject.tagName == 'A-SOUND')) {
          let mediaElement: any = src as any;
          mediaElement.pause();
          mediaElement.currentTime = 0;
        }
      });
    }    
  }

  getResponseObjectButton(sceneAssetRelationId: number){
    return document.querySelector("[response-object-entity-id$='"+sceneAssetRelationId+"']");
  }

  resetResponseObjectSrc(){
    let responseObjectButton = this.getResponseObjectButton(this.asset.sceneAssetRelation.sceneAssetRelationId);

    if(responseObjectButton){
      let entityId = responseObjectButton.getAttribute('entity-id');
      let responseId = responseObjectButton.getAttribute('response-id');
      let assetEntity = document.querySelector(`#entity-${entityId}-response-${responseId}-${this.assetType}`);
      if(assetEntity){
        let src = assetEntity.getAttribute('src');
        assetEntity.removeAttribute('src');
        setTimeout(() => {
          assetEntity.setAttribute('src', src);
        }, 200);
      }
    }
  }

  async saveMedia(files?){
    let mediaAsset = this.asset.baseAsset as MediaAsset;
    let data;
    
    if(this.selectedAssetIDToCopy > -1){
      data = {
        "assetManagementPageId": this.assetIDToCopy,
        "asset": this.asset
      };
      this.modalController.dismiss(data);
    }else if((mediaAsset.src && mediaAsset.src !== '') || this.selectedSrcUploaded !== ''){
      if(this.srcUploaded !== ''){     
        let mediaAssetSrc = await this.uploadFile(files);
        mediaAsset.src = mediaAssetSrc;
        if(this.assetType === 'Video'){
          mediaAsset.uploadStatus = 'uploading';
          mediaAsset.src = this.fileService.videoAssetUploadingPlaceholder;
          this.fileService.addVideoToCheckUploadStatus('baseAsset', this.asset.sceneAssetRelation.sceneAssetRelationId, mediaAsset, mediaAssetSrc);
          this.fileService.initialiseVideoUploadStatusCheck();
        }
      }
      data = {
        "asset": this.asset
      }
      this.modalController.dismiss(data);
    }else{
      this.modalController.dismiss(data);
    }
  }

}
